import authHttp from 'api';

export const connectHttp = authHttp.url('/connect');
